import axios from "axios"
import RestApiService from "./RestApiService"

const controller = "/transferenciaItems"

const TransferenciaItemsService = {
    buscar: async (transferencia_items) => {
        const { data } = await axios.post(`${controller}/buscar`, {
            transferencia_items
        })
        return data
    },
    buscarDetallexOrden: async (transferencia_items) => {
        const { data } = await axios.post(`${controller}/buscarDetallexOrden`, {
            transferencia_items
        })
        return data
    },
    registrar: async (request) => {
        return RestApiService.send(`${controller}/registrar`, request)
    },
    eliminar: async (transferencia_items) => {
        const { data } = await axios.post(`${controller}/eliminar`, {
            transferencia_items
        })
        return data
    },
    obtener: async (request) => {
        const { data } = await axios.post(`${controller}/obtener`, request)
        return data
    },
    ingresar: async (transferencia_items) => {
        const { data } = await axios.post(`${controller}/ingresar`, {
            transferencia_items
        })
        return data
    },
    historialTransferenciasxItem: async (producto_almacen) => {
        const { data } = await axios.post(`${controller}/historialTransferenciasxItem`, {
            producto_almacen
        })
        return data
    },


}

export default TransferenciaItemsService